<input
    #input
    autocomplete="off"
    type="time"
    [id]="labelForId()"
    [value]="inputValue()"
    [min]="minTime()"
    [max]="maxTime()"
    [step]="step()"
    [readonly]="readonly()"
    [required]="!readonly() && !!required()"
    [disabled]="disabled() === true"
    (focus)="onFocus($event)"
    (input)="onInput($event)"
    (change)="onInputChange($event)"
    (blur)="onBlur()"
/>
